import type { TFunction } from "i18next";

export const getVehicleCategoryLabel = (
  t: TFunction,
  category?: string
): string => {
  switch (category) {
    case "compact":
      return t("trips.tripCard.vehicleCategory.compact");
    case "compactElite":
      return t("trips.tripCard.vehicleCategory.compactElite");
    case "economy":
      return t("trips.tripCard.vehicleCategory.economy");
    case "economyElite":
      return t("trips.tripCard.vehicleCategory.economyElite");
    case "fullsize":
      return t("trips.tripCard.vehicleCategory.fullsize");
    case "fullsizeElite":
      return t("trips.tripCard.vehicleCategory.fullsizeElite");
    case "intermediate":
      return t("trips.tripCard.vehicleCategory.intermediate");
    case "intermediateElite":
      return t("trips.tripCard.vehicleCategory.intermediateElite");
    case "luxury":
      return t("trips.tripCard.vehicleCategory.luxury");
    case "luxuryElite":
      return t("trips.tripCard.vehicleCategory.luxuryElite");
    case "mini":
      return t("trips.tripCard.vehicleCategory.mini");
    case "miniElite":
      return t("trips.tripCard.vehicleCategory.miniElite");
    case "oversize":
      return t("trips.tripCard.vehicleCategory.oversize");
    case "premium":
      return t("trips.tripCard.vehicleCategory.premium");
    case "premiumElite":
      return t("trips.tripCard.vehicleCategory.premiumElite");
    case "special":
      return t("trips.tripCard.vehicleCategory.special");
    case "standard":
      return t("trips.tripCard.vehicleCategory.standard");
    case "standardElite":
      return t("trips.tripCard.vehicleCategory.standardElite");
    default:
      return "";
  }
};

export const getVehicleTypeLabel = (
  t: TFunction,
  vehicleType?: string
): string => {
  switch (vehicleType) {
    case "car":
      return t("trips.tripCard.vehicleTypeLabel.car");
    case "commercialVanTruck":
      return t("trips.tripCard.vehicleTypeLabel.commercialVanTruck");
    case "convertible":
      return t("trips.tripCard.vehicleTypeLabel.convertible");
    case "coupe":
      return t("trips.tripCard.vehicleTypeLabel.coupe");
    case "crossover":
      return t("trips.tripCard.vehicleTypeLabel.crossover");
    case "limousineSedan":
      return t("trips.tripCard.vehicleTypeLabel.limousineSedan");
    case "monospace":
      return t("trips.tripCard.vehicleTypeLabel.monospace");
    case "motorHome":
      return t("trips.tripCard.vehicleTypeLabel.motorHome");
    case "openAirAllTerrain":
      return t("trips.tripCard.vehicleTypeLabel.openAirAllTerrain");
    case "passengerVan":
      return t("trips.tripCard.vehicleTypeLabel.passengerVan");
    case "pickUp":
      return t("trips.tripCard.vehicleTypeLabel.pickUp");
    case "recreationalVehicle":
      return t("trips.tripCard.vehicleTypeLabel.recreationalVehicle");
    case "roadster":
      return t("trips.tripCard.vehicleTypeLabel.roadster");
    case "specialOfferCar":
      return t("trips.tripCard.vehicleTypeLabel.specialOfferCar");
    case "sportsCar":
      return t("trips.tripCard.vehicleTypeLabel.sportsCar");
    case "suv":
      return t("trips.tripCard.vehicleTypeLabel.suv");
    case "twoWheelVehicle":
      return t("trips.tripCard.vehicleTypeLabel.twoWheelVehicle");
    case "wagonEstate":
      return t("trips.tripCard.vehicleTypeLabel.wagonEstate");
    default:
      return "";
  }
};

export const getVehicleTitle = (
  t: TFunction,
  category?: string,
  vehicleType?: string,
  fallbackName?: string
): string => {
  const categoryLabel = getVehicleCategoryLabel(t, category);
  const typeLabel = getVehicleTypeLabel(t, vehicleType);
  const combined = [categoryLabel, typeLabel].filter(Boolean).join(" ");
  return combined || fallbackName || "";
};
